/**
 * FeatureInfoPanel - Displays feature information in the tour
 */
export class FeatureInfoPanel {
  constructor() {
    this.panel = null;
    this.isVisible = false;
    this.createPanel();
  }

  createPanel() {
    this.panel = document.createElement('div');
    this.panel.id = 'feature-info-panel';
    this.panel.style.cssText = `
      position: fixed;
      left: 20px;
      bottom: 80px;
      width: 320px;
      max-height: 400px;
      background: linear-gradient(135deg, rgba(30, 30, 30, 0.98) 0%, rgba(20, 20, 20, 0.98) 100%);
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 12px;
      padding: 20px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
      backdrop-filter: blur(10px);
      z-index: 900;
      display: none;
      opacity: 0;
      transition: opacity 0.3s ease, transform 0.3s ease;
      transform: translateY(20px);
      overflow-y: auto;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    `;
    
    document.body.appendChild(this.panel);
  }

  show(feature) {
    if (!feature) {
      this.hide();
      return;
    }

    // Build HTML
    let html = `
      <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 16px;">
        <span style="font-size: 32px;">${feature.icon}</span>
        <div style="flex: 1;">
          <h3 style="margin: 0; color: white; font-size: 18px; font-weight: 600;">${feature.label}</h3>
          ${feature.category ? `
            <div style="font-size: 11px; color: rgba(255,255,255,0.6); margin-top: 4px; text-transform: uppercase; letter-spacing: 0.5px;">
              ${feature.category}
            </div>
          ` : ''}
        </div>
      </div>
    `;

    if (feature.description) {
      html += `
        <p style="color: rgba(255,255,255,0.8); font-size: 13px; line-height: 1.6; margin: 0 0 16px 0;">
          ${feature.description}
        </p>
      `;
    }

    if (feature.specs && feature.specs.length > 0) {
      html += `
        <div style="background: rgba(255,255,255,0.05); border-radius: 8px; padding: 12px;">
          <h4 style="margin: 0 0 10px 0; color: white; font-size: 12px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px;">
            Specifications
          </h4>
          <ul style="margin: 0; padding: 0; list-style: none;">
            ${feature.specs.map(spec => `
              <li style="color: rgba(255,255,255,0.9); font-size: 13px; line-height: 1.8; padding-left: 20px; position: relative;">
                <span style="position: absolute; left: 0; color: ${feature.highlight_color};">${spec.icon || '•'}</span>
                ${spec.spec_text}
              </li>
            `).join('')}
          </ul>
        </div>
      `;
    }

    this.panel.innerHTML = html;
    this.panel.style.display = 'block';
    
    // Trigger animation
    setTimeout(() => {
      this.panel.style.opacity = '1';
      this.panel.style.transform = 'translateY(0)';
    }, 10);

    this.isVisible = true;
  }

  hide() {
    this.panel.style.opacity = '0';
    this.panel.style.transform = 'translateY(20px)';
    
    setTimeout(() => {
      this.panel.style.display = 'none';
    }, 300);

    this.isVisible = false;
  }

  dispose() {
    if (this.panel && this.panel.parentNode) {
      this.panel.parentNode.removeChild(this.panel);
    }
  }
}








